import React, { Component } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import Logo from "../static/images/Mapua-MCL-Logo.webp";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  SignOutUser(){
    localStorage.clear();
    document.getElementById('btnLogOut').setAttribute('style','hidden');
  }

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm small ng-white border-bottom box-shadow" container light>
                <NavbarBrand id="btnHome" className="text-light btn-home" tag={Link} to="/">
                    <img
                        alt="MMCL Logo"
                        src={Logo}
                        className="me-3"
                        height="35px"
                    />
                    Admissions Portal
                </NavbarBrand>
                <NavbarToggler onClick={this.toggleNavbar} className="mr-2 text-light navbar-dark" />
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
            <ul className="navbar-nav flex-grow">
            
            <NavItem>
                <NavLink className="text-light btn-logout"tag={Link} to="/sign-in" id="btnLogOut" onClick={this.SignOutUser} >Log-out</NavLink>
            </NavItem>
            {/*}
            <NavItem>
                <NavLink className="text-light"tag={Link} to="/sign-up">Sign up</NavLink>
              </NavItem>
              {/*
              <NavItem>
                <NavLink className="text-light" tag={Link} to="/">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="text-light" tag={Link} to="/counter">Counter</NavLink>
              </NavItem>
              <NavItem>
                <NavLink className="text-light" tag={Link} to="/fetch-data">Fetch data</NavLink>
              </NavItem>
    */}
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
